var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayVisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 63.36 21.12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.2687 0.0258398C36.7699 0.0258398 32.7495 2.41893 32.7495 6.84034C32.7495 11.9108 39.8798 12.261 39.8798 14.8083C39.8798 15.8808 38.6821 16.841 36.6365 16.841C33.7334 16.841 31.5636 15.4994 31.5636 15.4994L30.6352 19.9611C30.6352 19.9611 33.1348 21.0943 36.4533 21.0943C41.3719 21.0943 45.2423 18.5837 45.2423 14.0868C45.2423 8.72885 38.0824 8.38902 38.0824 6.02477C38.0824 5.18446 39.0656 4.2639 41.1053 4.2639C43.4067 4.2639 45.2844 5.23959 45.2844 5.23959L46.193 0.930392C46.193 0.930392 44.15 0.0258398 41.2687 0.0258398ZM0.108981 0.351093L1.95312e-05 1.00153C1.95312e-05 1.00153 1.8927 1.35699 3.59733 2.06614C5.79216 2.87924 5.94857 3.35264 6.3182 4.82289L10.3462 20.7589H15.746L24.0646 0.351093H18.6773L13.3321 14.2265L11.1509 2.46501C10.9509 1.11896 9.93765 0.351093 8.6974 0.351093H0.108981ZM26.2309 0.351093L22.0047 20.7589H27.1419L31.3533 0.351028H26.2309V0.351093ZM54.883 0.351093C53.6442 0.351093 52.9879 1.03174 52.5062 2.22112L44.9798 20.7589H50.3672L51.4095 17.6692H57.9727L58.6066 20.7589H63.36L59.2131 0.351093H54.883ZM55.5836 5.86465L57.1805 13.5226H52.9023L55.5836 5.86465Z",
    fill: "var(--fill-0, #1434CB)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.36,
    height: 21.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayVisa);
export default __webpack_public_path__ + "static/media/pay-visa.559f212e8abc82557bdcea9e5b052916.svg";
export { ForwardRef as ReactComponent };